// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UnbxdTitleArea-module__wrapper","removeDealBtn":"UnbxdTitleArea-module__removeDealBtn","h1Area":"UnbxdTitleArea-module__h1Area"};